import cx from "classnames";
import { ReactNode } from "react";

interface SidebarSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

const SidebarSection = ({ title, description, children, className }: SidebarSectionProps) => (
  <section className={cx("sidebar-section", className)}>
    <div className="sidebar-section__header">
      <p className="sidebar-section__title">{title}</p>
      {description && <p className="sidebar-section__description">{description}</p>}
    </div>
    <div className="sidebar-section__content">{children}</div>
  </section>
);

export default SidebarSection;
